import React,{ Component } from 'react';
import CategoryDrilldownView from './CategoryDrilldownView';
import { Category, categoryAddRecord, categoryFetchRecord, categoryUpdateRecord } from '../../store/models/Category';
import _ from 'lodash';
import { notification } from 'antd';

export default class CategoryDrilldownContainer extends Component {
  constructor(props) {
    super(props);
    if (props.newCat) {
      this.state = CategoryDrilldownContainer.getDerivedStateFromProps(props, {
        tagsText: '',
        isSaving: false,
        loading: false,
        loaded: true,
        loadError: false,
        cat: new Category(),
      });
    } else {
      this.state = CategoryDrilldownContainer.getDerivedStateFromProps(props, {
        tagsText: '',
        isSaving: false,
        loading: false,
        loaded: false,
        loadError: false,
      });
    }
  }

  static getDerivedStateFromProps(props, state = {}) {
    return { ...props, ...state };
  }

  componentDidMount() {
    if (!this.props.newCat) {
      const name = this.currentCatName;
      this.setState(
        { loading: true, loaded: false, cat: null },
        () => {
          categoryFetchRecord(name, this.token)
            .then((data) => {
              const cat = new Category(data);
              const tagsText = cat.tagsToText();
              this.setState({
                loaded: true, loading: false, cat, tagsText,
              });
            })
            .catch((err) => {
              this.setState({ loaded: false, loading: false, loadError: err });
            });
        },
      );
    }
  }

  get token() {
    return _.get(this, 'props.ephemeralKey.bearerToken');
  }

  get currentCatName() {
    return _.get(this, 'props.match.params.categoryName');
  }


  goHome() {
    this.props.history.push('/');
  }

  goBack() {
    this.props.history.push('/categories');
  }

  chooseName(e) {
    if (this.state.cat) {
      const name = _.get(e, 'target.value', '');
      this.state.cat.categoryName = name;
      this.setState({ cat: this.state.cat.clone() });
    }
  }

  chooseVersion(e) {
    if (this.state.cat) {
      const version = _.get(e, 'target.value', '');
      this.state.cat.version = version;
      this.setState({ cat: this.state.cat.clone() });
    }
  }

  chooseNotes(e) {
    if (this.state.cat) {
      const notes = _.get(e, 'target.value', '');
      this.state.cat.notes = notes;
      this.setState({ cat: this.state.cat.clone() });
    }
  }

  chooseDescription(e) {
    if (this.state.cat) {
      const description = _.get(e, 'target.value', '');
      this.state.cat.categoryDescription = description;
      this.setState({ cat: this.state.cat.clone() });
    }
  }

  chooseQuery(e) {
    if (this.state.cat) {
      this.state.cat.query = e;
      this.setState({ cat: this.state.cat.clone() });
    }
  }

  chooseTags(e) {
    const tagsText = _.get(e, 'target.value', '');
    if (this.state.cat) {
      this.state.cat.textToTags(tagsText);
      this.setState({ tagsText, cat: this.state.cat.clone() });
    } else {
      this.setState({ tagsText });
    }
  }

  get canSave() {
    return _.get(this, 'state.cat.isValid');
  }

  _saveCategory() {
    const token = _.get(this, 'props.ephemeralKey.bearerToken');
    if (this.props.newCat) {
      return categoryAddRecord(this.state.cat, token);
    }
    return categoryUpdateRecord(this.currentCatName, this.state.cat, token);
  }

  async save() {
    const name = _.trim(_.get(this, 'state.cat.categoryName', ''));
    if (this.state.isSaving) {
      return;
    }

    if (!this.canSave) {
      return notification.error({
        message: `could not save ${name}`,
        description: 'Sorry.',
      });
    }

    this.setState({ isSaving: true }, async () => {
      try {
        await this._saveCategory();

        this.setState({ isSaving: false }, () => {
          let description;
          if (this.props.newCat) {
            description = 'created Category';
          } else {
            description = 'saved Category';
          }

          let s = setTimeout(() => {
            this.goBack();
            s = null;
          }, 2000);

          notification.success({
            message: `Category "${name}"`,
            description,
            duration: 2.5,
            placement: 'topLeft',
            onOK() {
              if (s) {
                clearTimeout(s);
              }
              this.goBack();
            },
          });
        });
      } catch (err) {
        this.setState({ isSaving: false, saveError: err });
        notification.error({
          message: `could not save ${name}`,
          description: _.get(err, 'error', _.get(err, 'message', 'unknown error')),
        });
      }
    });
  }

  render() {
    return (
      <CategoryDrilldownView
        {...this.state}
        title={this.props.newCat ? 'New Category' : `Edit Category "${this.currentCatName}"`}
        goHome={() => this.goHome()}
        goBack={() => this.goBack()}
        canSave={this.canSave}
        name={this.currentCatName}
        save={() => this.save()}
        chooseName={(...args) => this.chooseName(...args)}
        chooseVersion={(...args) => this.chooseVersion(...args)}
        chooseNotes={(...args) => this.chooseNotes(...args)}
        chooseQuery={(...args) => this.chooseQuery(...args)}
        chooseTagsText={(...args) => this.chooseTags(...args)}
        chooseDescription={(...args) => this.chooseDescription(...args)}
      />
    );
  }
}
